module.exports = __webpack_public_path__ + "static/media/plaza.34297c23.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/data/images/plaza.jpg
 ** module id = 434
 ** module chunks = 0
 **/